module.exports = __webpack_public_path__ + "img/hardware1.2c86d13b.jpg";